import type { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { type RootState, UserRole } from '../common/types';

export const CreatorGuard: React.FC<PropsWithChildren> = ({ children }) => {
  const isNotAllowed = useSelector(
    (state: RootState) =>
      !((state.auth.user?.role ?? UserRole.Creator) === UserRole.Creator) &&
      !state.global.selectedCreatorProfile?.id
  );

  if (isNotAllowed) {
    return <Redirect to="/creators" />;
  }

  return children;
};
